import { Table } from "dyl-components";
import React from "react";

const DataHeader = () => {
    return (
        <Table.Header className="Table__header--primary">
            <Table.Row>
                <Table.HeaderCell>Name</Table.HeaderCell>
                <Table.HeaderCell width={10}>
                    URL
                </Table.HeaderCell>
                <Table.HeaderCell width={2}>Actions</Table.HeaderCell>
            </Table.Row>
        </Table.Header>
    );
};

export default DataHeader;
